module.exports = __webpack_public_path__ + "img/main_view_service.218f62de.png";